import { handlingResponse } from 'Utility/globalMethods';
import { axiosInstance as axios } from 'Api';

export const currentTime = () => {
	const tzOffset = new Date().getTimezoneOffset() * 60000;
	return new Date(Date.now() - tzOffset).toISOString().slice(0, -5).replace('T', ' ');
};

export const initLogger = () => {
	(function () {
		const oldLog = console.log;
		const oldError = console.error;
		console.log = function () {
			const args = Array.from(arguments);
			let console = Array.prototype.join.call(args, ' ').replace(/\s\s+/g, ' ');
			if (console.length > 300) {
				console = `${console.substring(
					0,
					300
				)}... <p><strong>[click the + icon to show the entire message]</strong></p>`;
			}
			const obj = {
				type: 'console',
				msg: `{"time": "${currentTime()}", "msg": "${console}", "extra": "${Array.prototype.join
					.call(args, ' ')
					.replace(/\s\s+/g, ' ')}", "type": "Debug"}`,
			};
			writeToLog(obj);
			oldLog.apply(console, args);
		};
		console.error = function () {
			const args = Array.from(arguments);
			let console = Array.prototype.join.call(args, ' ').replace(/\s\s+/g, ' ');
			if (console.length > 300) {
				console = `${console.substring(0, 300)}... [click the + icon to show the entire message]`;
			}
			const obj = {
				type: 'console',
				msg: `{"time": "${currentTime()}", "msg": "${console}", "extra": "${Array.prototype.join
					.call(args, ' ')
					.replace(/\s\s+/g, ' ')}", "type": "Error"}`,
			};
			writeToLog(obj);
			oldError.apply(console, args);
		};
	})();
};

export async function auth(params) {
	let data;
	try {
		data = await axios({
			method: 'post',
			url: `${process.env.LOGGER_SERVER}/login`,
			data: { ...params },
		});
		return handlingResponse(data);
	} catch (error) {
		return handlingResponse(error);
	}
}

export async function writeToLog(params) {
	let data;
	try {
		data = await axios({
			method: 'post',
			url: `${process.env.LOGGER_SERVER}/write`,
			data: { ...params },
		});
		return handlingResponse(data);
	} catch (error) {
		return handlingResponse(error);
	}
}

export async function getLog(params) {
	let data;
	try {
		data = await axios({
			headers: {
				Authorization: `Bearer ${window.sessionStorage.getItem('loggerAuth')}`,
			},
			method: 'post',
			url: `${process.env.LOGGER_SERVER}/retrieveLog`,
			data: { ...params },
		});
		const dataLog = data.data.msg.length > 0 ? data.data.msg.split('|') : [];
		data = [];
		if (dataLog.length > 0)
			dataLog.forEach((v) => {
				data.push(JSON.parse(v));
			});
		return data;
	} catch (error) {
		return handlingResponse(error);
	}
}

export async function getFile(params) {
	let data;

	try {
		data = await axios({
			headers: {
				Authorization: `Bearer ${window.sessionStorage.getItem('loggerAuth')}`,
			},
			method: 'get',
			url: `${process.env.LOGGER_SERVER}/getFile?filename=${params.filename}`,
		});
		return handlingResponse(data);
	} catch (error) {
		return handlingResponse(error);
	}
}
